export const CAROUSEL_URL = '/api/carousels/1/';
export const CATEGORIES_URL = '/api/categories';
export const ATTRIBUTES_URL = '/api/dealattribute/personal';
export const COLLECTIONS_URL = '/api/collections';
export const DEALS_URL = '/api/v2/deals/esbrowse';
export const FRONT_PAGE_DEAL_URL = '/frontpage-deal/';
export const FRONT_PAGE_SETTINGS_URL = '/api/frontpage-settings/';
export const REDEEM_GIFT_URL = 'account/giftcard/redeem';
export const PERSONAL_SMART_COLLECTIONS_URL = '/api/smartcollections/personal';
export const PROFILE_DATA_URL = '/api/account/profile';
export const RESET_PASSWORD_URL = '/account/password';
export const SMART_COLLECTIONS_URL = '/api/smartcollections';
export const USER_CREDITS_URL = 'api/users/account-credits';
export const USER_PLUS_URL = '/api/account/plus/';

export default {
  CAROUSEL_URL,
  CATEGORIES_URL,
  COLLECTIONS_URL,
  DEALS_URL,
  FRONT_PAGE_DEAL_URL,
  FRONT_PAGE_SETTINGS_URL,
  PERSONAL_SMART_COLLECTIONS_URL,
  PROFILE_DATA_URL,
  REDEEM_GIFT_URL,
  RESET_PASSWORD_URL,
  SMART_COLLECTIONS_URL,
  USER_CREDITS_URL,
  USER_PLUS_URL,
};
